import { useQuery, gql } from "@apollo/client";

const QUERY = gql`
  query GetAcknowledgedTerms($userId: Int!) {
    acknowledgedTermByUserId(userId: $userId) {
      isHost
      isGuest
    }
  }
`;

export function useAcknowledgedTerms(userId: number | null) {
  const { data, loading, refetch } = useQuery(QUERY, {
    variables: { userId },
    skip: !userId,
    fetchPolicy: "network-only",
  });
  const row = data?.acknowledgedTermByUserId;
  return {
    acknowledged: !!(row?.isGuest && row?.isHost),
    loading: !!userId && loading,
    refetch,
  };
}
